import Cookies from 'js-cookie';
import { getEnvironment } from 'utils/Window';
import { isEmpty } from 'lodash';

export function getItem(key) {
  return Cookies.get(key);
}

export function setItem(key, value, options) {
  Cookies.set(key, value, options);
}

export function removeItem(key) {
  Cookies.remove(key);
}

export function getCartKey(host) {
  const env = getEnvironment(host);
  return env === 'production' ? 'cart-redux' : `${env}-cart-redux`;
}

export function getCart(host) {
  const cookieKey = getCartKey(host);
  const cookie = getItem(cookieKey);
  return (cookie && !isEmpty(cookie) && JSON.parse(cookie)) || {};
}

export function getAffiliateKey() {
  const env = getEnvironment();
  return env === 'production' ? 'affiliate' : `${env}-affiliate`;
}

export function getAffiliate() {
  const cookieKey = getAffiliateKey();
  const cookie = getItem(cookieKey);
  return (cookie && !isEmpty(cookie) && JSON.parse(cookie)) || {};
}
